// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-container {
  background: #FDFDFD;
  border-radius: 16px;
  border: 1px solid #F3F3F3;
}
.question-container .icon-wrapper {
  padding: 10px;
  border-radius: 12px;
  background: #F8F8F8;
}
.question-container .icon-wrapper svg {
  width: 24px;
  height: 24px;
  fill: #717171;
}
.question-container .cta-icon svg,
.question-container .toggle-icon svg {
  width: 20px;
  height: 20px;
  fill: #101010;
}
.question-container:not(.disabled):hover {
  border: 1px solid #B7B7B7;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/containers/step-3/components/question/style.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;AACN;AAGE;;EAEE,WAAA;EACA,YAAA;EACA,aAAA;AADJ;AAIE;EACE,yBAAA;AAFJ","sourcesContent":[".question-container {\n  background: theme('colors.white');\n  border-radius: 16px;\n  border: 1px solid theme('colors.grey-10');\n\n  .icon-wrapper {\n    padding: 10px;\n    border-radius: 12px;\n    background: theme('colors.grey-5');\n\n    svg {\n      width: 24px;\n      height: 24px;\n      fill: theme('colors.grey-70');\n    }\n  }\n\n  .cta-icon svg,\n  .toggle-icon svg {\n    width: 20px;\n    height: 20px;\n    fill: theme('colors.black');\n  }\n\n  &:not(.disabled):hover {\n    border: 1px solid theme('colors.grey-50');\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
